<template>
  <div>
    <div class="container-fluid bg-white trent pt-5 pb-5">
      <h4>
        Search Result
        <span v-if="searchName">
          for:
          <b style="text-transform: capitalize">{{searchName}}</b>
        </span>
      </h4>
      <div class="underline-green"></div>
      <div class="boxes" v-if="products.length">
        <ProductCard v-for="product in products" :key="product.id" :product="product" />
      </div>
      <!-- IF NO SEARCH RESULT -->
      <div class="card py-5" v-else>
        <div class="card-body">
          <p class="lead">
            Search result not found
            <span v-if="searchName">
              for
              <b style="text-transform: capitalize">{{searchName}}</b>
            </span>
          </p>
        </div>
      </div>
    </div>
    <RelatedProducts />
    <!-- SHOW LOADING -->
    <LoadingComponent v-if="loading" />
  </div>
</template>

<script>
import ProductCard from "../components/ProductCard";
import RelatedProducts from "../components/RelatedProducts";
import LoadingComponent from "../components/LoadingComponent";
export default {
  name: "Search",
  components: {
    ProductCard,
    RelatedProducts,
    LoadingComponent
  },
  data() {
    return {
      showSearch: false
    };
  },

  computed: {
    products() {
      return this.$store.state.searchs;
    },
    searchName() {
      return this.$store.state.searchName;
    },
    loading() {
      return this.$store.state.componentIsLoading;
    }
  },
  methods: {
    // PROCESS LOADING
    processLoading: function() {
      this.$store.state.componentIsLoading = true;
      setTimeout(() => {
        this.closeLoading();
      }, 3000);
    },
    // CLOSE LOADING
    closeLoading: function() {
      if (this.$store.state.componentIsLoading) {
        this.$store.state.componentIsLoading = false;
      }
    }
  },
  beforeCreate() {
    if (this.$store.state.componentIsSearching == false) {
      this.$router.push("/");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.state.componentIsSearching = false;
    next();
  },
  mounted() {
    this.processLoading();
    this.$store.state.showSearch = false;
  }
};
</script>

<style></style>
